import { render, staticRenderFns } from "./SettingsUserListing.vue?vue&type=template&id=60f4d6a6&scoped=true&"
import script from "./SettingsUserListing.vue?vue&type=script&lang=js&"
export * from "./SettingsUserListing.vue?vue&type=script&lang=js&"
import style0 from "./SettingsUserListing.vue?vue&type=style&index=0&id=60f4d6a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4d6a6",
  null
  
)

export default component.exports